module.exports = __webpack_public_path__ + "static/media/trailMix.1c7d57ca.png";